import defaultProfile from "./default";
import type { ConfigSection, GameProfile, type Menu, ProfileCtx } from "./types";
import { commonMenuItems } from "./common";
import { i18n } from "@/i18n";
const { t } = i18n.global;

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "general" } },
  { component: "ConfSection", props: { name: "mapRotation" } },
  { component: "TableSection", props: { name: "adminIDs" } },
  { component: "TableSection", props: { name: "bannedIDs" } },
  { component: "TableSection", props: { name: "ownerIDs" } },
  { component: "TableSection", props: { name: "whitelistIDs" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
});
